export default __webpack_public_path__ + "static/feature-trends-3f57222277bf2e1454a03ac1f6f8d275.png";